import React, { useContext } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { enqueueSnackbar } from 'notistack';
import { GridCellParams } from '@mui/x-data-grid-pro';

import { translate as t } from 'hooks/useTranslations';
import { RiskPoolSharingContext } from '../../context';
import { AppContext } from 'views/App/context';

interface RemoveButtonProps {
  params: GridCellParams;
  organizations: Array<{ id: string; name?: string }>;
}

const RemoveButton: React.FC<RemoveButtonProps> = ({ params, organizations }) => {
  const { hasPermission, currentOrganizationId } = useContext(AppContext);
  const { deleteRelation } = useContext(RiskPoolSharingContext);

  const row = params.row;
  if (!row) return null;

  const canDelete = currentOrganizationId && hasPermission('addRelatedOrg', currentOrganizationId);

  if (!canDelete) return null;

  const handleDelete = (orgId: string) => {
    const org = organizations.find((org) => org.id === orgId);
    const orgName = org?.name || '';
    deleteRelation(orgId, () => {
      const message = orgName
        ? t('riskPoolSharing.delete.messages.removedSuccessfully', '{{name}} removed successfully').replace('{{name}}', orgName)
        : t('riskPoolSharing.delete.messages.removedSuccessfully', 'Organization removed successfully');
      enqueueSnackbar(message, { variant: 'success' });
    });
  };

  return (
    <Tooltip title={t('riskPoolSharing.actions.remove')}>
      <IconButton
        size="small"
        onClick={(e) => {
          (e.currentTarget as HTMLButtonElement).blur();
          handleDelete(row.id);
        }}
        color="default"
      >
        <DeleteIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  );
};

export default RemoveButton;

